import { render, staticRenderFns } from "./PopupLayer.vue?vue&type=template&id=6ffc8727"
import script from "./PopupLayer.vue?vue&type=script&lang=js"
export * from "./PopupLayer.vue?vue&type=script&lang=js"
import style0 from "./PopupLayer.vue?vue&type=style&index=0&id=6ffc8727&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports